export default {
  name: 'marking--xmlRequestTicket',
  apiService: 'shoes',
  apiPath: '/xml/ticket/load',
};